import { Routes } from './components/Routes';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { initializePortal, PortalDataProvider } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
export const prepareApp = async () => {
  try {
    const {
      portalData
    } = await initializePortal();
    return {
      props: {
        portalData
      }
    };
  } catch (error) {
    console.error('Failed to fetch brand and theme data:', error);
  }
  return {};
};
export { getLocaleInfo } from 'portals-platform-lib';
const client = new DataFetchingClient();
export function AppComponent(props) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: /*#__PURE__*/_jsx(PortalDataProvider, {
      initialData: props.portalData,
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "app",
        children: /*#__PURE__*/_jsx(Routes, {})
      })
    })
  });
}